import he_IL from '../../date-picker/locale/he_IL';
export default he_IL;



// WEBPACK FOOTER //
// ./components/calendar/locale/he_IL.tsx